(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["growhaus-authority-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-growhaus-nav]').forEach((navigation) => {
      const menus = navigation.querySelectorAll(':scope > details');
      navigation.querySelectorAll('[data-growhaus-mega]').forEach((megaMenu) => {
        const triggers = megaMenu.querySelectorAll('[data-growhaus-mega-trigger]');
        const panels = megaMenu.querySelectorAll('[data-growhaus-mega-panel]');
        triggers.forEach((trigger) => {
          const activate = () => {
            const key = trigger.dataset.growhausMegaTrigger;
            triggers.forEach((item) => item.classList.toggle('is-active', item === trigger));
            panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.growhausMegaPanel === key));
          };
          trigger.addEventListener('mouseenter', activate);
          trigger.addEventListener('focus', activate);
        });
      });
      menus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          menus.forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.removeAttribute('open');
          });
        });
      });
      document.addEventListener('click', (event) => {
        if (navigation.contains(event.target)) return;
        menus.forEach((menu) => menu.removeAttribute('open'));
      });
      navigation.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        menus.forEach((menu) => menu.removeAttribute('open'));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
